<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && isAllowedForItem">
  <app-full-page-message *ngIf="isAllowedForItem.status != 1"></app-full-page-message>
  <div
    *ngIf="isAllowedForItem.status == 1 && localService.languageContent.user_info && localService.languageContent.create_account && localService.languageContent.local_locations">
    <div *ngIf="wrapper" class="center" style="max-width: 1100px;">
      <div class="row">
        <div class="col-md-6">
          <div class="banner custom_rows_body">
            <div class="row">
              <div>
                <label>{{localService.languageContent.user_info.basic_info}}</label>
                <i class="material-icons" style="float:right" *ngIf="wrapper.systemInfo.v8 == '0'"
                  (click)="onEdit(1)">mode_edit</i>
              </div>
            </div>
            <div class="row" *ngIf="!localService.isHideDummy">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.create_account.gender"></app-label>
              </div>
              <div class="col-7">{{wrapper.basic.v11 == '1' ? localService.languageContent.create_account.gender_male :
                (wrapper.basic.v11 == '2' ? localService.languageContent.create_account.gender_female :
                localService.languageContent.create_account.gender_transgender)}}</div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.create_account.name"></app-label>
              </div>
              <div class="col-7"><span
                  [ngClass]="localService.getLanguageCode(wrapper.basic.v1)">{{wrapper.basic.v2}}</span></div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.create_account.name_short"></app-label>
              </div>
              <div class="col-7"><span
                  [ngClass]="localService.getLanguageCode(wrapper.basic.v18)">{{wrapper.basic.v19}}</span></div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.user_info.ph_num"></app-label>
              </div>
              <div class="col-7"><span class="en">{{wrapper.basic.v10}}</span></div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.local_locations.country"></app-label>
              </div>
              <div class="col-7"><span
                  [ngClass]="localService.getLanguageCode(wrapper.basic.v12)">{{wrapper.basic.v13}}</span></div>
            </div>
            <div class="row" *ngIf="!localService.isHideDummy">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.local_locations.state"></app-label>
              </div>
              <div class="col-7"><span
                  [ngClass]="localService.getLanguageCode(wrapper.basic.v7)">{{wrapper.basic.v8}}</span></div>
            </div>
            <div class="row" *ngIf="!localService.isHideDummy">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.local_locations.district"></app-label>
              </div>
              <div class="col-7"><span
                  [ngClass]="localService.getLanguageCode(wrapper.basic.v5)">{{wrapper.basic.v6}}</span></div>
            </div>
            <div class="row" *ngIf="!localService.isHideDummy">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.local_locations.constituency"></app-label>
              </div>
              <div class="col-7"><span
                  [ngClass]="localService.getLanguageCode(wrapper.basic.v3)">{{wrapper.basic.v4}}</span></div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.local_locations.postal_code"></app-label>
              </div>
              <div class="col-7"><span class="en">{{wrapper.basic.v9}}</span></div>
            </div>
            <br />
            <div class="row">
              <div>
                <label>{{localService.languageContent.user_info.additional_info}}</label>
                <i class="material-icons" style="float:right" *ngIf="wrapper.systemInfo.v8 == '0'"
                  (click)="onEdit(2)">mode_edit</i>
              </div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.user_info.email"></app-label>
              </div>
              <div class="col-7"><span class="en">{{wrapper.basic.v14}}</span></div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.common.upi"></app-label>
              </div>
              <div class="col-7"><span class="en">{{wrapper.basic.v17}}</span></div>
            </div>
            <div class="row">
              <div class="col-5 label_right">
                <app-label [Text]="localService.languageContent.user_info.delivery_address"></app-label>
              </div>
              <div class="col-7">{{ wrapper.basic.v15 == '1' ? localService.languageContent.user_info.yes :
                localService.languageContent.user_info.no}}</div>
            </div>
            <div class="row">
              <app-qrcode-generator [value]="wrapper.basic.key"
                [title]="localService.languageContent.barcode.my_barcode" [categoryCode]="3" [isPopup]="false"
                [countryCode]="ctryCode"></app-qrcode-generator>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="banner custom_rows_body">
            <div class="row">
              <div>
                <label>{{localService.languageContent.user_info.my_links}}</label>
              </div>
            </div>
            <div class="row">
              <span class="button user_link"
                (click)="onRoute(1)">{{localService.languageContent.user_info.my_business}}</span>
            </div>
            <div class="row">
              <span class="button user_link"
                (click)="onRoute(2)">{{localService.languageContent.user_info.my_business_relationship}}</span>
            </div>
            <div class="row">
              <span class="button user_link"
                (click)="onRoute(3)">{{localService.languageContent.user_info.my_notifications}}</span>
            </div>
            <div class="row">
              <span class="button user_link"
                (click)="onRoute(4)">{{localService.languageContent.user_info.my_bills}}</span>
            </div>
            <div class="row">
              <span class="button user_link" *ngIf="!localService.isHideDummy"
                (click)="onRoute(5)">{{localService.languageContent.user_info.my_invoice}}</span>
            </div>
            <div class="row">
              <span class="button user_link"
                (click)="onRoute(6)">{{localService.languageContent.user_info.my_access}}</span>
            </div>
            <br />
            <div class="row">
              <div>
                <label>{{localService.languageContent.user_info.system_info}}</label>
                <i class="material-icons" style="float:right" *ngIf="userId != localService.selected.user"
                  (click)="onEdit(3)">mode_edit</i>
              </div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.application_lang"></app-label>
              </div>
              <div class="col-5">
                {{wrapper.systemInfo.v5}}
                <i class="material-icons" style="float:right" *ngIf="userId == localService.selected.user"
                  (click)="onEdit(4)">mode_edit</i>
              </div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.roles"></app-label>
              </div>
              <div class="col-5"></div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.is_active"></app-label>
              </div>
              <div class="col-5">{{ wrapper.systemInfo.v1 == '1' ? localService.languageContent.user_info.yes :
                localService.languageContent.user_info.no}}</div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.created_on"></app-label>
              </div>
              <div class="col-5"><span class="en">{{wrapper.systemInfo.v7 | localDate}}</span></div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.last_login_on"></app-label>
              </div>
              <div class="col-5"><span class="en">{{wrapper.systemInfo.v2 | localDate}}</span></div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.is_pwd_reset_required"></app-label>
              </div>
              <div class="col-5">{{ wrapper.systemInfo.v3 == '1' ? localService.languageContent.user_info.yes :
                localService.languageContent.user_info.no}}</div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.last_pasword_updated"></app-label>
              </div>
              <div class="col-5"><span class="en">{{wrapper.systemInfo.v4 | localDate}}</span></div>
            </div>
            <div class="row">
              <div class="col-7 label_right">
                <app-label [Text]="localService.languageContent.user_info.is_blocked"></app-label>
              </div>
              <div class="col-5">{{ wrapper.systemInfo.v8 == '1' ? localService.languageContent.user_info.yes :
                localService.languageContent.user_info.no}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer freeze_height">
      <i class="material-icons on_language_changed icon_adjust" style="top:7px;" (click)="onLoad()">refresh</i>
    </div>
  </div>
</div>
<div>
  <app-create-account *ngIf="ctryCode && userId && wrapper && wrapper.basic.v10" [(isOpenPopup)]="isOpenEditAccount"
    [id]="userId" [ctryCode]="ctryCode" [PhoneNumber]="wrapper.basic.v10.split(' ')[1]"
    (onClose)="onCloseEditAccount($event)"></app-create-account>
</div>